import { filtersToParams, SearchFiltersObject } from '@/lib/content-services/search/search'
import {
  DISQUALIFYING_FILTERS,
  PROMOTED_RESULTS,
  PromotedResultType,
  TERMS_FOR_PROMOTIONS,
  TERMS_KEYS_TYPE
} from '@/lib/content-services/search/promotedResults'

export function getPromotedResults(filters: SearchFiltersObject): PromotedResultType[] {
  if(filters.page > 1 || disqualified(filters)) return []

  const query = filters.query.toLowerCase()

  const promo = Object.keys(TERMS_FOR_PROMOTIONS).find((key: string) => {
    const termFields = TERMS_FOR_PROMOTIONS[key]
    const passed = termFields.predicates.every(predicate => predicate)
    const hasMatches = termFields.terms.some((matchWord: string) => query.includes(matchWord))

    return passed && hasMatches
  }) as TERMS_KEYS_TYPE;

  if(promo) {
    return PROMOTED_RESULTS[promo] as PromotedResultType[]
  }

  return []
}

export function stripTestData() {
}

function disqualified(filters: SearchFiltersObject) {
  const params = filtersToParams(filters)
  return DISQUALIFYING_FILTERS.some((disqualifyingFilter) => params.get(disqualifyingFilter))
}
